import React from 'react';
import { useIntl } from 'react-intl';
import { useVendorExpensesContext } from '@/pages/company/DashboardRoute/pages/VendorExpensesRoute/vendorExpensesContextProvider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import SelectCascading from '@/components/mui/Form/Select/SelectCascading';
import AutocompleteAsyncWithCheckboxes from '@/pages/company/DashboardRoute/pages/VendorExpensesRoute/components/Autocomplete/AutocompleteAsyncWithCheckboxes';

const VendorExpensesFilters = () => {
  const { formatMessage } = useIntl();
  const { fieldProps } = useVendorExpensesContext();

  return (
    <Box mb={2}>
      <Typography variant="subtitle1" sx={{ color: 'text.secondary', fontWeight: '500' }} mb={1}>
        {formatMessage({
          id: 'company.dashboard.vendorExpenses.filters.title',
          defaultMessage: 'Track vendor charges over time and identify trends in monthly spend',
        })}
      </Typography>

      <Stack direction="row" gap={2} flexWrap="wrap" alignItems="flex-start">
        <SelectCascading {...fieldProps.period} />
        <AutocompleteAsyncWithCheckboxes {...fieldProps.currencies} />
        <AutocompleteAsyncWithCheckboxes {...fieldProps.vendors} />
        <SelectCascading {...fieldProps.topVendors} />
      </Stack>
    </Box>
  );
};

export default VendorExpensesFilters;
